import {useDataSource} from "src/core/data-sources/decorators/withData";
import DocumentsDataSource from "../../user/data-sources/documents";
import {useMemo} from "react";

function useDocuments(hasDocument, documentType) {
  const documentsDataSource = useMemo(() => {
    return new DocumentsDataSource();
  }, []);

  return useDataSource(
    {hasDocument, documentType},
    {
      dataSource: documentsDataSource,
      dataField: "document",
    }
  );
}

export default useDocuments;
